module.exports = "/static/media/download_icon.aff6524f.svg";